function simpleDateParser(date) {
	return new Date(date).toISOString().slice(0, 10).split('-').reverse().join('-')
}

function simpleName(name) {
	const splitedName = name.split(' ')
	if (splitedName.length > 2) {
		return `${ splitedName[0] } ${ splitedName[splitedName.length - 1] }`
	}
	return name
}

function parseQueryParams(search) {
	if (!search) {
		return {}
	}
	return search.substring(1).split('&').map(param => param.split('=')).reduce((sum, ele) => {
		if (ele[0]) {
			sum[ele[0]] = (ele[1] || '')
		}
		return sum
	}, {})

}
module.exports = {
	simpleDateParser,
	parseQueryParams,
	simpleName
}



// WEBPACK FOOTER //
// ./src/client/utils/helpers.js